import homeVideoReview from "fragments/homeVideos/homeVideoReview"
import gql from "graphql-tag"

const GET_DRAFTS = gql`
  ${homeVideoReview}

  query getDrafts {
    drafts {
      ...HomeVideoReview
    }
  }
`
export default GET_DRAFTS
